var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.product.id,attrs:{"id":"chart"}},[_c('apex-chart',{attrs:{"type":"donut","height":_vm.height,"options":_vm.chartOptions,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }